<template>
  <v-card
    no-gutters
    elevation="0"
    class="px-4 py-2 modal-alert-container"
  >
    <div class="modal-alert-container__message">
      {{ alertMessage }} <a
        v-if="showLinkText"
        class="modal-alert-container__link"
        :href="linkReference"
        target="_blank"
        @click.stop
      >{{ linkText }}</a>
    </div>
    <v-btn
      depressed
      plain
      x-small
      :ripple="false"
      class="modal-alert-container__buttom px-0"
      @click.stop="closeAlert()"
    >
      <DsIcon
        name="close"
        size="small"
        dark
      />
    </v-btn>
  </v-card>
</template>

<script>
import { DsIcon } from '@ds/icons';

export default {
  name: 'ModalAlert',
  components: {
    DsIcon,
  },
  props: {
    alertMessage: {
      type: String,
      default: '',
      require: true,
    },
    linkText: {
      type: String,
      default: '',
    },
    linkReference: {
      type: String,
      default: '',
    },
  },
  computed: {
    showLinkText() {
      return Boolean(this.linkText.length);
    },
  },
  methods: {
    closeAlert() {
      this.$emit('close-alert');
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-alert-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--ds-border-radius-sm);

    &.v-card {
      &.v-sheet {
        &.theme--light {
          background: var(--gray-500) !important;
        }

        &.theme--dark {
          background: var(--ds-color-overlay) !important;
        }
      }
    }

    &__message {
      font-size: var(--ds-font-size-xs);
      line-height: var(--ds-font-line-height-slim);
      font-weight: var(--ds-font-weight-regular);
    }

    &__link {
      color: var(--ds-color-text-interactive);
      font-weight: var(--ds-font-weight-semibold);
      text-decoration-line: underline;
    }

    &__buttom {
      height: auto !important;
      min-width: auto !important;
    }
  }
</style>
